import React from "react";

class Step1 extends React.Component {
  render() {
    if (this.props.currentStep !== 1) {
      return null;
    }
    return (
      <React.Fragment>
        <div className="input-group mb-2">
          <div className="input-group-prepend">
            <div className="input-group-text">+ 91</div>
          </div>
          <input
            type="number"
            name="phone"
            placeholder="Enter your mobile no"
            data-form-field="phone"
            className="form-control"
            value={this.props.phone}
            onChange={this.props.handleChange}
            required
          />
        </div>
        <p className={`text-secondary ${this.props.display}`}>
          Please enter a valid number!
        </p>
      </React.Fragment>
    );
  }
}

export default Step1;
